import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons';
var Constants = require('../constants.json');

class TopicRightPane extends React.Component {
    openCloseRelatedBox = () => {
        if (document.querySelector(".related-container").style.maxHeight === "0px" ||
            document.querySelector(".related-container").style.maxHeight === "") {
            document.querySelector(".related-container").style.display = "block";
            document.querySelector(".related-container").style.maxHeight = "100vh";
            document.querySelector(".related-container").classList.add("related-p-20");
            document
                .querySelector(".related-mobile-arrow")
                .classList.add("related-mobile-arrow-rotate");
        } else {
            document.querySelector(".related-container").style.maxHeight = "0px";
            document
                .querySelector(".related-container")
                .classList.remove("related-p-20");
            document
                .querySelector(".related-mobile-arrow")
                .classList.remove("related-mobile-arrow-rotate");
            document.querySelector(".related-container").style.display = "none";
        }
    };
    render() {
        return (
            <div className="related">
                {this.props.rightPane.length>0?
            <div>
                <div className="related-mobile">
                    <p>View Related Conditions</p>
                    <FontAwesomeIcon icon={faAngleDoubleUp} className="related-mobile-arrow" onClick={this.openCloseRelatedBox}/>
                </div>
                <div className="related-container">
                    <div className="related-content-box">
                        <p className="related-heading">Related Conditions</p>
                        {this.props.rightPane.map((item, index) => {
                            let cleanItem = item.replace(/[?;//%]/g, ' ');
                            return <p className="related-content" key={index}>
                                <Link to={"/topic-search/" + cleanItem + "/"+Constants["defaultGenus"]}
                                onClick={()=>{localStorage.setItem("genus",Constants["defaultGenus"])}}>{cleanItem}</Link>
                            </p>
                        })}

                    </div>
                </div>
            </div>:''}
            </div>
        )
    }
}

export default TopicRightPane;